const DoughnutData = (batery, removed, shot, alarm, acOut) => {
    // Garante arrays v�lidos
    const sum = arr => Array.isArray(arr) ? arr.reduce((a, b) => a + b, 0) : 0;
    const doughnutData = [
        sum(batery),
        sum(removed),
        sum(shot),
        sum(alarm),
        sum(acOut)
    ];

    return {
        doughnut: {
            labels: ["BATERIA BAIXA", "REMOVIDO", "DISPAROS", "ALARMES", "SEM REDE AC"],
            datasets: [{
                label: "Resumo",
                data: doughnutData
            }]
        }
    }
}

export default DoughnutData